<template>
  <div class="box sc-analytics-status">
    <h2 class="sc-analytics-status__title">{{title}}</h2>
    <sc-chart
      :options="chartData" />
  </div>
</template>

<script>
import {
  ScChart,
} from '@intelipost-js/secure-components';

export default {
  name: 'sc-analytics-status',
  props: {
    nameSpace: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    direction: {
      type: String,
      default: 'column',
    },
    rows: {
      type: Array,
    },
  },
  methods: {
    redirect(id) {
      const {
        warehouses,
        dateRange,
      } = this.$store.state.recon.analytics.filters.form;

      return this.$router.push({
        name: 'analytics-detail',
        params: {
          id,
        },
        query: {
          warehouses,
          dateRange,
        },
      });
    },
  },
  computed: {
    chartData() {
      return {
        chart: {
          type: this.direction,
        },
        title: {
          text: false,
        },
        xAxis: {
          type: 'category',
          labels: {
            rotation: -45,
            style: {
              fontSize: '13px',
              fontFamily: 'Verdana, sans-serif',
            },
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Total por Transportadora',
          },
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          pointFormat: 'Total de Pedidos: <b>{point.y:.0f}</b>',
        },
        series: [{
          name: 'Total por Transportadora',
          color: '#9bbd45',
          data: this.rows,
        }],
        plotOptions: {
          series: {
            point: {
              events: {
                click: (args) => {
                  const state = this.$store.state.recon.analytics[this.nameSpace].content;
                  const id = state
                    .find(item => item.logistic_provider_name === args.point.options.name);

                  const {
                    logistic_provider_id,
                  } = id;

                  this.redirect(logistic_provider_id);
                },
              },
            },
          },
        },
      };
    },
  },
  components: {
    ScChart,
  },
};
</script>

<style lang="scss" scoped>
  .sc-analytics-status {
    height: 100%;
    min-height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &__title {
      text-align: center;
      font-size: 1.3rem;
      margin: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/analytics/components/analytics-status/ScAnalyticsStatus.vue?3e24d9a8